import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import { Table, Pagination } from "antd";
import {
  itemRender,
  pageSizeOptions,
  defaultPagination,
  handlePageChange
} from "utils/table";
import { SkeltonLoader } from "components/skeltonLoader";
import Image from "components/Image";
import { getUniformStockApi, getUniformStockSummaryApi } from "api/services/uniforms";
import { useSearchParams } from 'react-router-dom';
import UniformStockFilter from "../components/UniformStockFilter";
import UniformStockFilterDrawer from "components/Drawer/uniformStockFilterDrawer";
import useUniformStockFilter from "../hooks/uniformStockFilterHook";
import { format } from "date-fns";
import { formatDateHandler2 } from "utils/common";
const UniformStock = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [stockData, setStockData] = useState([]);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const [pageSettings, setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("page_size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_by") || ""
  });

  const {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading,
    setFilterLoading,
    handleDateChange
  } = useUniformStockFilter(pageSettings, setPageSettings);

  const getFilterParams = useCallback(() => {
    let _filters = [...filters].filter(item => item.value);
    const filter_params = _filters.reduce((acc, item) => {
      acc[item.key] = item.value;
      return acc;
    }, {});
    return filter_params;
  }, [filters]);

  const setStockParams = (pageData) => {
    let filter_params = getFilterParams();
    let params = {
      page_size: pageData?.pageSize,
      page: pageData?.page,
      sort_by: pageData?.sortBy || "",
      sort_type: pageData?.sortType || "",
      ...filter_params
    };
    setSearchParams(params);
  };

  const getStockData = () => {
    setLoading(true);
    setFilterLoading(true);
    
    let filter_params = getFilterParams();
    
    // Format date if present
    if (filter_params?.stock_date) {
      filter_params.stock_date = format(new Date(filter_params.stock_date), "yyyy-MM-dd");
    }

    let ordering = ""
    if(pageSettings?.sortType === "ascend"){
        ordering = "-" + pageSettings?.sortBy;
    } else {
        ordering = pageSettings?.sortBy;
    }
    console.log(ordering, "ordering---->>>");

    getUniformStockSummaryApi({

      page_size: pageSettings?.pageSize,
      page: pageSettings?.page,
      ordering,
      ...filter_params
    })
      .then((response) => {
        console.log(response.data.results, "stock data---->>>");
        setStockData(response.data.results || response.data);
        setPageSettings({
          ...pageSettings,
          total: response.data.count || response.data.length
        });
        setLoading(false);
        setFilterLoading(false);
        setShowFilterDrawer(false);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
        setFilterLoading(false);
      });
  };

  useEffect(() => {
    getStockData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters]);

  useEffect(() => {
    setStockParams(pageSettings);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSettings]);

  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings);
    console.log(pageData);
    setPageSettings(pageData);
  };

  const handleFilterDrawer = () => {
    setShowFilterDrawer(!showFilterDrawer);
    setFilterLoading(false);
  };

  const handleApplyFilter = () => {
    setPageSettings({
      ...pageSettings,
      page: 1,
      filters
    });
  };

  const columns = [
    {
      title: "Uniform Image",
      dataIndex: "uniform_name",
      render: (text, record) => (
        <a className="avatar">
          <Image 
            src={record?.uniform?.image} 
            type="user" style={{ objectFit: "cover" }}
          />
        </a>
      )
    },
    {
      title: "Uniform Name",
      dataIndex: "uniform_name",
      sorter: true,
      render: (text, record) => (
        <Link to={`/uniforms/${record?.uniform?.id}`} className="table-avatar">
          {record?.uniform?.name || "N/A"}
        </Link>
      )
    },
    {
      title: "Size",
      dataIndex: "size_name",
      sorter: true,
      render: (text, record) => (
        <span className="badge badge-soft-secondary px-2 py-1">
          {record?.size?.code || "N/A"}
        </span>
      )
    },
    {
      title: "Total Quantity",
      dataIndex: "total_quantity",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record.total_quantity || 0}
        </span>
      )
    },
    {
      title: "Stock Count",
      dataIndex: "stock_count",
      render: (text, record) => (
        <span className="table-avatar">
          {record.stock_count || 0}
        </span>
      )
    },
    {
      title: "Latest Stock Date",
      dataIndex: "latest_stock_date",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record.latest_stock_date) || "N/A"}
        </span>
      )
    },
    {
      title: "Allocated Quantity",
      dataIndex: "allocated_quantity",
      render: (text, record) => (
        <span className="table-avatar">
          {record.allocated_quantity || 0}
        </span>
      )
    },
    {
      title: "Available Quantity",
      dataIndex: "available_quantity",
      render: (text, record) => (
        <span className="table-avatar">
          {record.available_quantity || 0}
        </span>
      )
    }
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Uniform Stock"
            title="Dashboard"
            subtitle="Uniform Stock"
          />

          <UniformStockFilter
            filters={filters}
            handleInputChange={handleInputChange}
            searchPlaceholder={"Search Uniform Stock"}
            handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
          />

          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                <style>{`
                  .modern-table .ant-table-tbody > tr {
                    background-color: #ffffff !important;
                  }
                  .modern-table .ant-table-tbody > tr:hover > td {
                    background-color: #f5f5f5 !important;
                  }
                  .modern-table .ant-table-thead > tr > th {
                    background-color: #f8f9fa !important;
                    font-weight: 600;
                    color: #333;
                    border-bottom: 2px solid #e0e0e0;
                    padding: 10px 12px;
                    font-size: 13px;
                  }
                  .modern-table .ant-table-tbody > tr > td {
                    border-bottom: 1px solid #f0f0f0;
                    padding: 10px 12px;
                    font-size: 13px;
                  }
                  .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                    border-top: 1px solid #f0f0f0;
                    background-color: #ffffff;
                    border-bottom-left-radius: 12px;
                    border-bottom-right-radius: 12px;
                  }
                `}</style>
                <div className="table-responsive" style={{ overflowX: "auto" }}>
                  <Table
                    className="mb-0 modern-table"
                    style={{ 
                      borderRadius: "12px",
                      minWidth: "100%"
                    }}
                    scroll={{ x: "max-content" }}
                    columns={columns}
                    dataSource={stockData}
                    rowKey={(record, index) => `${record?.uniform?.id}-${record?.size?.id || 'no-size'}-${index}`}
                    loading={loading}
                    pagination={{
                      total: pageSettings?.total,
                      pageSize: pageSettings?.pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: pageSizeOptions,
                      itemRender: itemRender,
                      position: "bottom-right",
                      current: pageSettings?.page,
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${total} items`,
                      style: { padding: "16px" }
                    }}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <UniformStockFilterDrawer
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}
        handleFilterChange={handleFilterChange}
        filters={filters}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
      />
    </>
  );
};

export default UniformStock;

